import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-catalogs-selector',
  standalone: true,
  imports: [],
  templateUrl: './catalogs-selector.component.html',
  styleUrl: './catalogs-selector.component.scss'
})
export class CatalogsSelectorComponent {
  @Input() catalogs: any = [];
  @Input() isDetail: boolean = true;
  @Output() getCategory = new EventEmitter<any>();

  constructor() {}

  updateProducts(categoria: string = '', subcategoria:string = '') {
    this.getCategory.emit({categoria, subcategoria });
  }
}
